<template>
  <b-row class="content-header">
    <!-- Content Left -->
    <b-col
      v-if="showBreadcrumb"
      class="content-header-left my-2 pr-0"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <div class="breadcrumb-wrapper">
            <b-breadcrumb 
              class="px-0"
              :class="{ 'nexos-breadcrumb': isNexos }">

              <!-- Parent Home -->
              <b-breadcrumb-item 
                v-if="showParentCollectiveBreadcrumb"
                :to="parentCollectiveRoute">
                <b-icon-house />
                {{ translateTranslationTable (currentLocale, parentCollective.name) || parentCollective.title }}
              </b-breadcrumb-item>

              <!-- Home -->
              <b-breadcrumb-item :to="collectiveHomeLocation">
                <b-icon-house v-if="isNexos && !showParentCollectiveBreadcrumb" />
                {{ translateTranslationTable (currentLocale, currentCollective.name) || currentCollective.title }}
              </b-breadcrumb-item>

              <!-- Breadcrumbs -->
              <b-breadcrumb-item
                v-for="(item, index) in breadcrumbs"
                :key="index"
                :active="item.active"
                :to="getItemLocation(item)"
              >
                {{ getItemText(item) }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BIconHouseFill,
} from 'bootstrap-vue';
import { ENABLED_APPS_GETTERS } from '@/store/enabled-apps/enabled-apps-store-constants';
import GridStatusMixin from '@core/mixins/apps-layout/GridStatusMixin';
import { translateTranslationTable } from '@/@core/libs/i18n/utils';

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BIconHouseFill,
  },
  mixins: [GridStatusMixin],
  data() {
    return {
      isChatRoomVisible: false,
      exBread: null,
    };
  },
  computed: {
    currentLocale() {
      return this.$store.state.locale.currentLocale;
    },
    showBreadcrumb() {
      return this.isNexos || (this.breadcrumbs && this.breadcrumbs.length);
    },
    breadcrumbs() {
      try {
      if (this.$route.meta?.pageTitle == null || this.isHome) {
        return null;
      }
      if (this.$store.getters['app/breadcrumbs']) {
        this.exBread = this.$store.getters['app/breadcrumbs'];
        if (this.exBread.length === 1) {
          let name = this.$t(this.$route.meta.pageTitle);
          let object = [
            {
              text: name,
              active: true,
            },
          ];

          const app = Object.values(this.$store.getters.apps?.apps || {}).find(
            (x) => x.name?.[this.$store.state.locale.currentLocale] === name,
          );
          if (
            app && (app.key === 'people' || app.key === 'entities')
            && ![null, 'noKey'].includes(this.$route.params?.typeKey)
          ) {
            const arr = this.$store.getters.types?.[app.key].unpaginated;
            const type = arr.find((x) => x.key === this.$route.params?.typeKey);

            if (app.customization?.[type?.key] != null) {
              name = app.customization[type.key]?.customizationName || app.customization[type.key];

              if (typeof (name) === 'object') {
                if (Object.keys(name).includes(
                  this.$store.getters.currentLocale,
                )) {
                  name = this.translateTranslationTable(this.$store.state.locale.currentLocale, name);
                  if (typeof (name) === 'object') {
                    name = Object.values(name)[0];
                  }
                } else {
                  name = Object.values(name)[0];
                }
              }
            } else if (
              Object.keys(type.namePlural).includes(
                this.$store.getters.currentLocale,
              )
            ) {
              name = this.translateTranslationTable(this.$store.state.locale.currentLocale, type.namePlural);
            } else {
              name = Object.values(type.namePlural)[0];
            }

            object = [
              {
                text: name,
                active: true,
              },
            ];

            return object;
          }
          if (app?.customizationName) {
            name = translateTranslationTable(
              this.$store.state.locale.currentLocale,
              app.customizationName,
            );
          }
          object = [
            {
              text: name,
              active: true,
            },
          ];
          this.exBread = name;
          return object;
        }
        return this.exBread;
      }
      let name = this.$t(this.$route.meta.pageTitle);
      if (name.length === 0 || typeof name !== 'string') {
        return null;
      }
      let app = Object.values(this.$store.getters.apps?.apps || {}).find(
        (x) => x.name?.[this.$store.state.locale.currentLocale] === name,
      );

      if (app == null) {
        app = Object.values(this.$store.getters.apps?.apps || {}).find(
          (x) => x.name?.[this.$store.state.locale.currentLocale].includes(name),
        );
      }
      if (app?.customizationName) {
        name = translateTranslationTable(
          this.$store.state.locale.currentLocale,
          app.customizationName,
        );
      }
      const object = [
        {
          text: name,
          active: true,
        },
      ];
      this.exBread = name;
      return object;
    } catch (error) {
        console.error("breadcrumbs",error);
      }
    },
    isHome() {
      return this.$route.name === 'Resumen';
    },
    currentCollective() {
      return this.$store.getters.currentCollective;
    },
    mainCollective() {
      return this.$store.getters.mainCollective;
    },
    mainSpace() {
      return this.mainCollective.key ? this.mainCollective : this.currentCollective;
    },
    parentCollective() {
      return this.$store.getters.parentCollective;
    },
    isNexos() {
      return process.env.VUE_APP_CUSTOMER === 'nexos' || this.mainSpace?.key === 'f3166db0-b635-11ef-805d-f79ce25412de';
    },
    showParentCollectiveBreadcrumb() {
      return this.isNexos && (this.parentCollective && this.parentCollective.slug);
    },
    collectiveHomeLocation() {
      let hash = this.$route.name;
      if (this.$route.meta?.goBackAnchor) {
        hash = typeof this.$route.meta.goBackAnchor === 'function'
          ? this.$route.meta.goBackAnchor(this.$route)
          : this.$route.meta.goBackAnchor;
      }
      return {
        name: 'Resumen',
        params: {
          communityId: this.currentCollective.slug || undefined,
        },
        hash: `#${hash}`,
      };
    },
    parentCollectiveRoute() {
      return {
        name: 'Resumen',
        params: {
          communityId: this.parentCollective.slug || undefined,
        },
      };
    },
    isEditingLayout() {
      return this.$store.getters[ENABLED_APPS_GETTERS.isEditingLayout];
    },
  },
  methods: {
    translateTranslationTable(locale, data) {
      return translateTranslationTable(locale, data);
    },
    getItemLocation(item) {
      if (!item.to) return null;

      return typeof item.to === 'function'
        ? item.to(item, this.$route)
        : {
          ...item.to,
          params: {
            communityId: this.$route.params.communityId,
            ...(item.to.params || {}),
          },
        };
    },
    getItemText(item) {
      let text = '';
      if (typeof item.text === 'function') {
        text = item.text(item, this.$route, this.$store);
      } else {
        text = item.text;
      }

      if (this.$te(text)) {
        if (this.$t(text).hasOwnProperty('title')) {
          const { title } = this.$t(text);
          return title.toLowerCase();
        }
        return this.$t(text);
      }
      return text;
    },
  },
};
</script>
